import { Stack, Title } from "@mantine/core";

import { MealsSection } from "./Meals/MealsSection";

export const Home = () => {
  return (
    <Stack gap="xl">
      <Title order={1}>Home</Title>
      <MealsSection />
    </Stack>
  );
};
